import React, { Component } from 'react';
import RoleUtils from '../utils/RoleUtils';
import { db, realtimeDb, firebase } from '../firebase/firebase';
import { auth } from '../firebase/index.js';
import { showSnackbarWithType } from '../components/Snackbar.js';
import withAuthorization from '../components/withAuthorization';
import Modal from 'react-modal';
import moment from 'moment';
import {
    APIProvider,
    Map,
    Marker,
} from '@vis.gl/react-google-maps';
import { Table } from 'element-react';
import FileService from '../utils/FileService';

import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

import AudioRecorder from '../components/AudioRecorder.js';
import { Divider } from '@material-ui/core';

const isImage = (type) => {
    const imageTypes = ['jpg', 'jpeg', 'png', 'webp'];
    return imageTypes.some(imageType => type.startsWith(imageType));
};

const isVideo = (type) => {
    const videoTypes = ['mp4', 'mp3', 'wav'];
    return videoTypes.some(videoType => type.startsWith(videoType));
};

class MeldingenDetailsScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            newAttachments: [],
            showPostalcodesModal: false,
            toBeRemovedPostalcodes: [],
            initialPostalCodes: [],
            postalCodes: [],
            postalCodeInput: '',
            lastSelectedMelding: null,
            showMapModal: false,
            showAddUpdateModal: false,
            showAttachmentsModal: false,
            selectedAttachments: [],
            selectedUpdate: null,
            chatMessages: [],
            oldestTimestamp: null,
            newestTimestamp: null,
            updateText: '',
            chatText: '',
            showAddChatMessageModal: false,
            fetchedUsers: [],
            fetchedUser: null,
            showMessageActionsDialog: false,
            showUserProfileDialog: false,
            showLastMessageAndCloseDialog: false,
            showClickedMediaDialog: false,
            clickedMedia: null,
            lastMessageInput: '',
            audioChunks: [],
            mediaRecorder: null,
            updateTableColumns: [
                {
                    label: "Datum",
                    prop: "ts",
                    width: 160,
                    render: (data) => {
                        if (data.ts) {
                            return typeof data.ts === 'number'
                                ? moment(data.ts).format("D MMMM - HH:mm")
                                : moment(data.ts.toDate()).format("D MMMM - HH:mm");
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Bijlages",
                    prop: "files",
                    width: 90,
                    render: (data) => {
                        if (data.files && data.files.length > 0) {
                            return <span className="badge badge-secondary" onClick={() => {
                                this.loadAttachmentsFromData(data)();
                                this.setState({ showAttachmentsModal: true, selectedUpdate: data })
                            }}>{data.files.length}x</span>;
                        } else {
                            return <span className="badge badge-secondary"></span>;
                        }
                    }
                },
                {
                    label: "Inhoud",
                    prop: "text",
                    width: 1580,
                    render: (data) => {
                        if (data.invisible) {
                            return <div><span className="badge badge-light" style={{ marginLeft: 6, marginRight: 6 }}>Onzichtbaar</span> {data.text ? data.text : ''}</div>;
                        } else {
                            return data.text ? data.text : '';
                        }
                    },
                },
                {
                    label: "Acties",
                    fixed: 'right',
                    width: 120,
                    render: (data) => {
                        return (
                            <div>
                                <button type="button" className="btn btn-primary" onClick={() => this.setState({ updateText: data.text, selectedUpdate: data, showAddUpdateModal: true })}><i className="material-icons" title="Wijzigen" data-toggle="tooltip">edit</i></button>
                                <button type="button" className="btn btn-danger" onClick={() => this.deleteUpdateFromMelding(data.id)}><i className="material-icons" title="Onzichtbaar maken" data-toggle="tooltip">visibility_off</i></button>
                            </div>
                        );
                    }
                }
            ],
            msgTableColumns: [
                {
                    label: "Datum",
                    prop: "ts",
                    width: 160,
                    render: (data) => {
                        if (data.ts) {
                            return typeof data.ts === 'number'
                                ? moment(data.ts).format("D MMMM - HH:mm")
                                : moment(data.ts.toDate()).format("D MMMM - HH:mm");
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Bijlages",
                    prop: "files",
                    width: 90,
                    render: (data) => {
                        if (data.files && data.files.length > 0) {
                            return <span className="badge badge-secondary" onClick={() => {
                                this.loadAttachmentsFromData(data)();
                                this.setState({ showAttachmentsModal: true, selectedUpdate: data })
                            }}>{data.files.length}x</span>;
                        } else {
                            return <span className="badge badge-secondary"></span>;
                        }
                    }
                },
                {
                    label: "Inhoud",
                    prop: "text",
                    width: 1580,
                    render: (data) => {
                        const userData = this.props.rootUserData;
                        if (data.invisible) {
                            return <div><span className="badge badge-light" style={{ marginLeft: 6, marginRight: 6 }}>Onzichtbaar</span> {data.text ? data.text : ''}</div>;
                        } else if (userData && data.uid === userData.uid) {
                            return <div><span className="badge badge-secondary" style={{ marginLeft: 6, marginRight: 6 }}>Jij</span> {data.text ? data.text : ''}</div>;
                        } else if (data.urole) {
                            return <div><span className="badge badge-primary" style={{ marginLeft: 6, marginRight: 6 }}>{data.urole}</span> {data.text ? data.text : ''}</div>;
                        } else if (data.isUpdate) {
                            return <div><span className="badge badge-success" style={{ marginLeft: 6, marginRight: 6 }}>Update</span> {data.text ? data.text : ''}</div>;
                        } else {
                            return data.text ? data.text : '';
                        }
                    },
                },
                {
                    label: "Acties",
                    fixed: 'right',
                    width: 120,
                    render: (data) => {
                        return (
                            <div>
                                <button className={data.invisible ? 'btn btn-success' : 'btn btn-danger'}
                                    onClick={() => {
                                        const userData = this.props.rootUserData;

                                        if (data.invisible) {
                                            realtimeDb.ref(`chats/${this.state.lastSelectedMelding.id}/messages/${data.id}`).update({
                                                invisible: false,
                                                invisibleAt: null,
                                                invisibleBy: null,
                                            });

                                            showSnackbarWithType('Zichtbaar gemaakt', 'success');
                                        } else {
                                            realtimeDb.ref(`chats/${this.state.lastSelectedMelding.id}/messages/${data.id}`).update({
                                                invisible: true,
                                                invisibleAt: firebase.database.ServerValue.TIMESTAMP,
                                                invisibleBy: userData.uid,
                                            });

                                            showSnackbarWithType('Bericht onzichtbaar gemaakt', 'success');
                                        }

                                        this.setState({ lastSelectedChatMessage: null });

                                    }}>
                                    <i className="material-icons" title="Onzichtbaar maken" data-toggle="tooltip">{data.invisible ? 'visibility' : 'visibility_off'}</i>
                                </button>
                                <button className="btn btn-info"
                                    onClick={() => {
                                        this.setState({ showMessageActionsDialog: false });
                                        setTimeout(() => {
                                            this.fetchUserData(this.state.lastSelectedChatMessage.uid);
                                        }, 400);
                                    }}>
                                    <i className="material-icons" title="Bekijk gebruiker" data-toggle="tooltip">person</i>
                                </button>
                            </div>
                        );


                    }
                }
            ]
        }

        this.meldingenListener = null;
        this.chatListener = null;
    }

    componentDidMount() {
        this.getMyWorkareas();

        const { chatMessages } = this.state;
        const meldingFromStorageAsString = localStorage.getItem('lastSelectedMelding');
        let meldingFromStorage = null;

        if (meldingFromStorageAsString) {
            meldingFromStorage = JSON.parse(meldingFromStorageAsString);
            console.log('meldingFromStorage', meldingFromStorage);
            this.setState({ lastSelectedMelding: meldingFromStorage });
        }

        this.meldingenListener = realtimeDb.ref(`meldingen/${meldingFromStorage.id}`);

        this.meldingenListener.on('value', (snapshot) => {
            const melding = snapshot.val();
            if (melding) {
                console.log('Melding details updated:', melding);
                this.setState({ lastSelectedMelding: melding });
                localStorage.setItem('lastSelectedMelding', JSON.stringify(melding));
            } else {
                console.warn('Melding not found in database.');
                this.setState({ lastSelectedMelding: null });
                localStorage.removeItem('lastSelectedMelding');
            }
        });

        this.meldingenListener.on('child_changed', (snapshot) => {
            const updatedMelding = snapshot.val();
            console.log('Melding child changed:', updatedMelding);
            this.setState(prevState => {
                const updatedLastSelectedMelding = { ...prevState.lastSelectedMelding, [snapshot.key]: updatedMelding };
                localStorage.setItem('lastSelectedMelding', JSON.stringify(updatedLastSelectedMelding));
                return { lastSelectedMelding: updatedLastSelectedMelding };
            });
        });

        // Load the initial chat messages
        realtimeDb.ref(`chats/${meldingFromStorage.id}/messages`).orderByChild('ts').limitToLast(20).once('value', snapshot => {
            const chatMessages = snapshot.val();
            if (chatMessages) {
                const messagesArray = Object.values(chatMessages).sort((a, b) => a.ts - b.ts);
                this.setState({
                    chatMessages: messagesArray,
                    oldestTimestamp: messagesArray.length > 0 ? messagesArray[0].ts : null,
                    newestTimestamp: messagesArray.length > 0 ? messagesArray[messagesArray.length - 1].ts : null
                }, () => {
                    setTimeout(() => {
                        if (this.flatListRef) {
                            this.flatListRef.scrollToEnd({ animated: false });
                        }
                    }, 300);
                });
            }
        });

        this.chatListener = realtimeDb.ref(`chats/${meldingFromStorage.id}/messages`).orderByChild('ts');

        this.chatListener.on('child_added', snapshot => {
            const newMessage = snapshot.val();
            if (newMessage) {
                this.setState(prevState => ({
                    chatMessages: [...prevState.chatMessages, newMessage],
                    newestTimestamp: Math.max(prevState.newestTimestamp, newMessage.ts)
                }));
            }
        });

        this.chatListener.on('child_changed', snapshot => {
            const updatedMessage = snapshot.val();
            if (updatedMessage) {
                this.setState(prevState => ({
                    chatMessages: prevState.chatMessages.map(msg => msg.id === updatedMessage.id ? updatedMessage : msg),
                }));
            }
        });
    }

    getMyWorkareas = async () => {
        const userData = await auth.getUserData();
        console.log(userData);
        this.setState({ userData, workareas: [] });
        const workareasRef = realtimeDb.ref(`/workareas/${userData.uid}`);

        workareasRef.on('value', (snapshot) => {
            let workareas = snapshot.val();
            console.log('Fetched workareas:', workareas);

            if (!workareas) {
                workareas = [];
            }

            this.setState({ workareas });
        });
    }

    componentWillUnmount() {
        if (this.meldingenListener) {
            this.meldingenListener.off();
            this.meldingenListener = null;
        }
        if (this.chatListener) {
            this.chatListener.off();
            this.chatListener = null;
        }

        const { attachments } = this.state;
        attachments.forEach(attachment => {
            if (attachment.url) {
                URL.revokeObjectURL(attachment.url); // Clean up the URL object
            }
        });
    }

    fetchUserData = async (uid) => {
        try {
            const { fetchedUsers } = this.state;

            const existingUser = fetchedUsers.find(user => user.uid === uid);

            if (existingUser) {
                this.setState({
                    fetchedUser: existingUser,
                    showMessageActionsDialog: false, showUserProfileDialog: true
                });
                return existingUser;
            }

            const userSnapshot = await db.collection('users').doc(uid).get();
            if (!userSnapshot.exists) {
                console.warn(`User with uid ${uid} does not exist.`);
                return null;
            }
            const userData = userSnapshot.data();
            if (!userData) {
                console.warn(`User data for uid ${uid} is null or undefined.`);
                return null;
            }

            this.setState({
                fetchedUsers: [...this.state.fetchedUsers, { uid, ...userData }],
                fetchedUser: { uid, ...userData },
                showMessageActionsDialog: false, showUserProfileDialog: true
            });

            return userData;
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    }

    closeMapModal = () => {
        this.setState({ showMapModal: false });
    }

    addMessageToMelding = async () => {
        console.log('Adding message to melding:', this.state.chatText);
        const { lastSelectedMelding, chatText } = this.state;
        const userData = this.props.rootUserData;
        const newAttachments = this.state.newAttachments || [];
        let uploadedFiles = [];

        if (!chatText || chatText.trim() === '') {
            console.warn('message text is empty, not adding update.');
            return;
        }

        if (newAttachments.length > 0) {
            const uploadPromises = newAttachments.map(async file => {
                const response = await FileService.uploadFileBrowser(file, lastSelectedMelding.id);
                console.log('File uploaded successfully:', response);
                return response;
            });

            uploadedFiles = await Promise.all(uploadPromises);
        }

        let msgRef = realtimeDb.ref(`chats/${lastSelectedMelding.id}/messages`).push();

        let newMessage = {
            id: msgRef.key,
            text: chatText,
            files: [],
            ts: firebase.database.ServerValue.TIMESTAMP,
            uid: userData.uid,
        };

        let isPoliceRole = RoleUtils.hasRole(userData, RoleUtils.Roles.Politie);
        let isWijkAgentRole = RoleUtils.hasRole(userData, RoleUtils.Roles.WijkAgent);
        let isGemeenteRole = RoleUtils.hasRole(userData, RoleUtils.Roles.Gemeente);

        if (isPoliceRole || isWijkAgentRole || isGemeenteRole) {
            newMessage.urole = isPoliceRole ? 'politie' : isWijkAgentRole ? 'wijkagent' : isGemeenteRole ? 'gemeente' : null;
        }

        if (uploadedFiles.length > 0) {
            if (!newMessage.files) {
                newMessage.files = [];
            }

            newMessage.files.push(...uploadedFiles);
        }

        realtimeDb.ref(`chats/${lastSelectedMelding.id}/lastMessage`).set({
            id: msgRef.key,
            text: chatText,
            ts: firebase.database.ServerValue.TIMESTAMP,
            uid: userData.uid,
        });

        msgRef.set(newMessage).then(() => {
            this.setState({ chatText: '', showAddChatMessageModal: false, newAttachments: [] });
        });
    }

    addUpdateToMelding = async () => {
        const { lastSelectedMelding, selectedUpdate, updateText } = this.state;
        const userData = this.props.rootUserData;
        const newAttachments = this.state.newAttachments || [];
        let uploadedFiles = [];

        if (!updateText || updateText.trim() === '') {
            console.warn('Update text is empty, not adding update.');
            return;
        }

        const existingUpdate = lastSelectedMelding.updates && Object.values(lastSelectedMelding.updates).find(u => u.id === selectedUpdate?.id);

        if (newAttachments.length > 0) {
            const uploadPromises = newAttachments.map(async file => {
                const response = await FileService.uploadFileBrowser(file, lastSelectedMelding.id);
                console.log('File uploaded successfully:', response);
                return response;
            });

            uploadedFiles = await Promise.all(uploadPromises);
        }

        const meldingRef = realtimeDb.ref(`meldingen/${lastSelectedMelding.id}`);
        let updateRef = selectedUpdate == null ? meldingRef.child('updates').push() : realtimeDb.ref(`meldingen/${lastSelectedMelding.id}/updates/${selectedUpdate.id}`);

        let newUpdate = {
            id: updateRef.key,
            text: updateText,
            ts: existingUpdate ? existingUpdate.ts : firebase.database.ServerValue.TIMESTAMP,
            uid: userData.uid,
            isUpdate: true,
        };

        if (existingUpdate) {
            newUpdate.updatedAt = firebase.database.ServerValue.TIMESTAMP;
            newUpdate.files = existingUpdate.files;
        }

        if (uploadedFiles.length > 0) {
            if (!newUpdate.files) {
                newUpdate.files = [];
            }

            newUpdate.files.push(...uploadedFiles);
        }

        if (selectedUpdate != null) {
            if (selectedUpdate.invisible) {
                newUpdate.invisible = selectedUpdate.invisible;
                newUpdate.invisibleAt = selectedUpdate.invisibleAt;
                newUpdate.invisibleBy = selectedUpdate.invisibleBy;
            }
        }

        updateRef.set(newUpdate).catch(error => {
            console.error('Error adding update:', error);
        });

        meldingRef.child('updatedAt').set(firebase.database.ServerValue.TIMESTAMP);

        const msgRef = realtimeDb.ref(`chats/${lastSelectedMelding.id}/messages/${updateRef.key}`);
        realtimeDb.ref(`chats/${lastSelectedMelding.id}/lastMessage`).set(newUpdate);
        msgRef.set(newUpdate);

        showSnackbarWithType('Opgeslagen', 'success');

        this.setState({ updateText: '', selectedUpdate: null, showAddUpdateModal: false, newAttachments: [] });
    }

    deleteUpdateFromMelding = (updateId) => {
        const { lastSelectedMelding } = this.state;
        const userData = this.props.rootUserData;
        if (!updateId) {
            console.warn('Update ID is null or undefined, not deleting update.');
            return;
        }
        const updateRef = realtimeDb.ref(`meldingen/${lastSelectedMelding.id}/updates/${updateId}`);
        updateRef.update({
            invisible: true,
            invisibleAt: firebase.database.ServerValue.TIMESTAMP,
            invisibleBy: userData.uid,
        }).catch(error => {
            console.error('Error deleting update:', error);
        });

        showSnackbarWithType('Onzichtbaar gemaakt', 'success');
    }

    loadAllAttachmentsFromMelding = () => async () => {
        const { lastSelectedMelding, attachments } = this.state;
        if (!lastSelectedMelding || !lastSelectedMelding.id) {
            console.warn('No selected melding or melding ID found.');
            return;
        }

        const response = await FileService.getAllFiles(lastSelectedMelding.id);

        if (response.files && response.files.length > 0) {
            // Resolve all file URLs
            const filesWithUrls = await Promise.all(
                response.files.map(async (file) => ({
                    ...file,
                    url: await FileService.getFileUrl(file.filename, lastSelectedMelding.id)
                }))
            );
            this.setState({ attachments: filesWithUrls });
        }
        else {
            console.warn('No attachments found for this melding.');
        }
    }

    loadAttachmentsFromData = (data) => async () => {
        if (!data || !data.files || data.files.length === 0) {
            console.warn('No attachments found in this update.');
            return;
        }

        const selectedAttachments = await Promise.all(
            data.files.map(async (file) => {
                const fileUrl = await FileService.getFileUrl(file.filename, this.state.lastSelectedMelding.id);
                return {
                    ...file,
                    url: fileUrl,
                    isImage: isImage(file.type),
                    isVideo: isVideo(file.type)
                };
            })
        );
        this.setState({ selectedAttachments });
    }

    clearActiveClassNameFromTabs = (ele) => {
        const tabs = document.getElementById('meldingenDetailsTabs').childNodes || [];
        tabs.forEach(tab => {
            tab.classList.remove('active');
        });
        ele.target.classList.add('active');

        if (ele.target.id === 'attachments-tab') {
            // dont remove ()
            this.loadAllAttachmentsFromMelding()();
        }
    }

    extendPostcode(postcode) {
        let extended = [];
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (let i = 0; i < 26; i++) {
            for (let j = 0; j < 26; j++) {
                extended.push(postcode + letters[i] + letters[j]);
            }
        }
        return extended;
    }

    handleSavePostalcodes = () => {
        const { postalCodes, toBeRemovedPostalcodes } = this.state;
        const { lastSelectedMelding } = this.state;

        if (!lastSelectedMelding || !lastSelectedMelding.id) {
            console.warn('No selected melding or melding ID found.');
            return;
        }

        const updatedPostalCodes = [...new Set([...postalCodes])];
        realtimeDb.ref(`meldingen/${lastSelectedMelding.id}/postalCodes`).set(updatedPostalCodes);
        const updatesWithPostalcodes = {};
        updatedPostalCodes.forEach(pc => {
            if (pc.length === 4) {
                // postcode needs to be extended to all combinations of AA to ZZ - like 1234AA, 1234AB, ..., 1234ZZ
                const extendedPostcodes = this.extendPostcode(pc);
                extendedPostcodes.forEach(epc => {
                    updatesWithPostalcodes[`${epc}/${lastSelectedMelding.id}`] = firebase.database.ServerValue.TIMESTAMP;
                });

                updatesWithPostalcodes[`${pc}_mk/${lastSelectedMelding.id}`] = firebase.database.ServerValue.TIMESTAMP;
            }

            updatesWithPostalcodes[`${pc}/${lastSelectedMelding.id}`] = firebase.database.ServerValue.TIMESTAMP;
        });

        // check if postcodes need to be removed too
        toBeRemovedPostalcodes.forEach(pc => {
            updatesWithPostalcodes[`${pc}/${lastSelectedMelding.id}`] = null; // remove this postcode
            if (pc.length === 4) {
                // postcode needs to be extended to all combinations of AA to ZZ - like 1234AA, 1234AB, ..., 1234ZZ
                const extendedPostcodes = this.extendPostcode(pc);
                extendedPostcodes.forEach(epc => {
                    updatesWithPostalcodes[`${epc}/${lastSelectedMelding.id}`] = null; // remove this postcode
                });
            }
        });

        realtimeDb.ref(`meldingen_by_postalcodes`).update(updatesWithPostalcodes);

        this.setState({ showPostalcodesModal: false, initialPostalCodes: [], postalCodes: [], toBeRemovedPostalcodes: [] });
    }

    render() {
        const { fetchedUser, attachments } = this.state;
        const userData = this.props.rootUserData;

        if (userData && (!RoleUtils.hasRole(userData, RoleUtils.Roles.Wijkagent) && !RoleUtils.hasRole(userData, RoleUtils.Roles.Gemeente) && !RoleUtils.hasRole(userData, RoleUtils.Roles.Administrator))) {
            return (
                <div className="container content">
                    <div className="alert alert-danger" role="alert">
                        Je hebt geen toegang tot deze pagina.
                    </div>
                </div>
            );
        }

        const meldingFromStorageAsString = localStorage.getItem('lastSelectedMelding');
        const melding = meldingFromStorageAsString ? JSON.parse(meldingFromStorageAsString) : null;

        if (!melding) {
            return (
                <div className="container logboek content" style={{ maxWidth: 2600 }}>
                    <button type="button" className="btn btn-secondary btn-raised" onClick={() => this.props.history.push('/meldingen')}>
                        Terug naar meldingen overzicht
                    </button>
                    <h4 className="modal-title">Melding details</h4>
                    <p>Geen melding geselecteerd.</p>
                </div>
            );
        }

        return (
            <div className="container logboek content" style={{ width: '100%', maxWidth: 1920, backgroundColor: '#fff' }}>
                <div className="row" style={{ border: "1px solid #ddd", backgroundColor: '#e8f4ff', padding: '1em', marginBottom: 6 }}>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary btn-raised" onClick={() => this.props.history.push('/meldingen')}>
                            Terug naar meldingen overzicht
                        </button>
                        <h4 className="modal-title">Melding details</h4>
                        <span className="badge badge-primary" style={{ marginRight: 6 }}>{melding.subject}</span><span className="badge  badge-secondary">Status: {melding.status}</span>
                        <span className="badge badge-light" style={{ marginLeft: 6, marginRight: 6 }}>{moment(melding.timestamp).format("D MMMM YYYY - HH:mm")}</span>
                        <span className="badge badge-light" style={{ marginLeft: 6, marginRight: 6 }} onClick={() => this.setState({ showMapModal: true })}>{melding.address ? melding.address + ' (tik hier voor kaart)' : 'Onbekend'}</span>
                        <Divider style={{ marginTop: 6, marginBottom: 6 }} />
                        <div style={{ marginTop: 6, marginBottom: 6 }}>
                            <strong>Acties: </strong>
                            <button type="button" className="btn btn-primary btn-raised" onClick={() => this.setState({ showPostalcodesModal: true, initialPostalCodes: melding.postalCodes || [], postalCodes: melding.postalCodes || [] })} style={{ marginRight: 6 }}>
                                Postcodes wijzigen ({melding.postalCodes ? melding.postalCodes.length : '0'})
                            </button>
                            <button type="button" className="btn btn-primary btn-raised" onClick={() => this.setState({ showLastMessageAndCloseDialog: true, lastMessageInput: '' })} style={{ marginRight: 6 }}>
                                Melding afsluiten met bericht
                            </button>
                            <button type="button" className="btn btn-primary btn-outline" onClick={() => this.setState({ showMapModal: true })} style={{ marginRight: 6 }}>
                                Bekijk locatie op kaart
                            </button>
                        </div>
                        <Divider style={{ marginTop: 6, marginBottom: 6 }} />
                        <div className="nav nav-tabs" id="meldingenDetailsTabs" role="tablist" style={{ marginBottom: 6 }}>
                            <a onClick={this.clearActiveClassNameFromTabs} className="nav-item nav-link active" id="details-tab" data-toggle="tab" href="#details" role="tab" aria-controls="details" aria-selected="true">Details</a>
                            <a onClick={this.clearActiveClassNameFromTabs} className="nav-item nav-link" id="updates-tab" data-toggle="tab" href="#updates" role="tab" aria-controls="updates" aria-selected="false">Updates ({melding.updates ? Object.keys(melding.updates).length : '0'})</a>
                            <a onClick={this.clearActiveClassNameFromTabs} className="nav-item nav-link" id="chat-tab" data-toggle="tab" href="#chat" role="tab" aria-controls="chat" aria-selected="false">Chat</a>
                            <a onClick={this.clearActiveClassNameFromTabs} className="nav-item nav-link" id="attachments-tab" data-toggle="tab" href="#attachments" role="tab" aria-controls="chat" aria-selected="false">Bijlages</a>
                        </div>
                    </div>
                </div>

                <div className="tab-content" id="meldingenDetailsTabContent">
                    <div className="tab-pane fade active in" id="details" role="tabpanel" aria-labelledby="details-tab">
                        {melding.closingMessage ? <><p><strong>Afgesloten met bericht:</strong></p><p>{melding.closingMessage.text}</p></> : ''}
                        <p><strong>Postcodes:</strong> {melding.postalCodes.map((code, index) => (
                            <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                {code}
                            </span>
                        ))}</p>
                        <p><strong>Beschrijving:</strong></p>
                        <p>{melding.description}</p>
                    </div>
                    <div className="tab-pane fade" id="updates" role="tabpanel" aria-labelledby="updates-tab">
                        <span>Deel belangrijke informatie met alle gebruikers die de melding in de app zien; deze verschijnt ook in de Chat als update.</span>
                        <div className="row">
                            <div className="col-sm-1 text-center">
                                <button type="button" className="btn btn-primary btn-raised" onClick={() => this.setState({ showAddUpdateModal: true, selectedUpdate: null })}>+ Nieuwe update</button>
                            </div>
                        </div>
                        <div>
                            <Table
                                style={{ width: '100%' }}
                                columns={this.state.updateTableColumns}
                                data={melding.updates ? Object.values(melding.updates) : []}
                                stripe={true}
                                highlightCurrentRow={true}
                                height={720}
                                onCurrentChange={selectedUpdate => this.setState({ selectedUpdate })}
                            />
                        </div>
                    </div>
                    <div className="tab-pane fade" id="chat" role="tabpanel" aria-labelledby="chat-tab">
                        <div className="row">
                            <div className="col-sm-1 text-center">
                                <button type="button" className="btn btn-primary btn-raised" onClick={() => this.setState({ showAddChatMessageModal: true, chatText: '' })}>+ Nieuwe bericht</button>
                            </div>
                        </div>
                        <div>
                            <Table
                                style={{ width: '100%' }}
                                columns={this.state.msgTableColumns}
                                data={this.state.chatMessages}
                                stripe={true}
                                highlightCurrentRow={true}
                                height={720}
                                onCurrentChange={lastSelectedChatMessage => this.setState({ lastSelectedChatMessage })}
                            />
                        </div>
                    </div>

                    <div className="tab-pane fade" id="attachments" role="tabpanel" aria-labelledby="attachments-tab">
                        <div>
                            {attachments && attachments.length > 0 ? <span>Geuploade bestanden door gebruikers uit de chat.</span> : <span>Geen bestanden door gebruikers geüpload.</span>}
                            <div className="attachments-list" style={{ marginTop: 10 }}>
                                {attachments && attachments.length > 0 ? (
                                    <LightGallery
                                        speed={500}
                                        plugins={[lgZoom, lgThumbnail]}
                                    >
                                        {attachments.map((attachment, index) => (
                                            isImage(attachment.type) && (
                                                <a key={index} href={attachment.url} target="_blank" rel="noopener noreferrer">
                                                    <img src={attachment.url} crossOrigin="anonymous" alt={attachment.name} style={{ padding: 6, maxWidth: 200, maxHeight: 200, borderRadius: 4, objectFit: 'cover' }} />
                                                </a>
                                            )

                                        ))}

                                    </LightGallery>
                                ) : (
                                    <p></p>
                                )}
                            </div>
                            <div className="attachments-list" style={{ marginTop: 10, borderTop: '1px solid gray' }}>
                                {attachments && attachments.length > 0 ? (
                                    <LightGallery
                                        speed={500}
                                        plugins={[lgZoom, lgThumbnail]}
                                    >
                                        {attachments.map((attachment, index) => (
                                            isVideo(attachment.type) && (
                                                <video
                                                    controls
                                                    poster=".\assets\updatet_wewatch_transparent.png" preload="none"
                                                    style={{ maxWidth: 200, maxHeight: 200, borderRadius: 4, marginRight: 6, marginBottom: 6 }}>
                                                    <source src={attachment.url} type={'video/' + attachment.type} />
                                                </video>
                                            )

                                        ))}

                                    </LightGallery>
                                ) : (
                                    <p></p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showPostalcodesModal}
                    onRequestClose={() => this.setState({ showPostalcodesModal: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Postcodes</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showPostalcodesModal: false, initialPostalCodes: [], postalCodes: [] })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Sluiten</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span><strong>Huidige postcodes:</strong></span>
                            <div style={{ marginBottom: '1em' }}>
                                {this.state.postalCodes && this.state.postalCodes.length > 0 ? (
                                    this.state.postalCodes.map((code, index) => (
                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px', cursor: 'pointer', padding: '0.5em', border: '1px solid rgb(221, 221, 221)' }}>
                                            {code} <span style={{ backgroundColor: 'rgb(240, 240, 240)', position: 'relative', padding: '5px', right: '-6px', color: 'rgb(72, 72, 72)' }} onClick={() => {
                                                const updatedCodes = this.state.postalCodes.filter((_, i) => i !== index);
                                                this.setState({ postalCodes: updatedCodes, toBeRemovedPostalcodes: [...this.state.toBeRemovedPostalcodes, code] });
                                            }}>x</span>
                                        </span>
                                    ))
                                ) : (
                                    <span className="badge badge-secondary">Geen postcodes toegevoegd</span>
                                )}
                            </div>
                            <span className="accordion"><strong>Mijn opgeslagen werkgebieden.</strong> {this.state.workareas && this.state.workareas.length > 0 ? <span className="accordion-toggle btn btn-primary btn-sm btn-outline" style={{ borderRadius: 18 }} onClick={() => this.setState({ showWorkareasList: !this.state.showWorkareasList })}>{this.state.showWorkareasList ? 'Dichtklappen' : 'Tonen'}</span> : <span>Je hebt nog geen werkgebieden opgeslagen.</span>}</span>
                            <div className="form-group" style={{ width: '100%', borderBottom: '1px solid #ddd', paddingBottom: '1em' }}>
                                <div className={`werkgebieden-list ${this.state.showWorkareasList ? 'show' : 'hidden'}`}>
                                    {this.state.workareas && this.state.workareas.length > 0 ? (
                                        <ul className="list-group">
                                            {this.state.workareas.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center" style={{ padding: 0 }}>
                                                    <span>{item.label && item.label + ":"} {item.postcodes && item.postcodes.map((code, index) => (
                                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                                            {code}
                                                        </span>
                                                    ))}</span>
                                                    <button className="btn btn-primary btn-sm btn-outline" onClick={() => {
                                                        const updatedCodes = [...this.state.postalCodes, ...item.postcodes];
                                                        const uniqueCodes = [...new Set(updatedCodes)];
                                                        this.setState({ postalCodes: uniqueCodes });
                                                    }}>Toevoegen</button>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>Geen werkgebieden gevonden.</p>
                                    )}
                                </div>
                            </div>
                            <p>Voer een postcode in (1234AB - letters optioneel voor kleiner bereik)</p>
                            <div className="form-group" style={{ display: 'inline-flex', width: '100%' }}>
                                <input type="text" style={{ maxWidth: '300px', marginRight: '12px' }} className="form-control" placeholder="Postcode" value={this.state.postalCodeInput} onChange={(e) => this.setState({ postalCodeInput: e.target.value })} />
                                <button type="button" className="btn btn-primary btn-outline" onClick={() => {
                                    const { postalCodes, postalCodeInput } = this.state;

                                    if (postalCodes.includes(postalCodeInput.trim())) {
                                        showSnackbarWithType('Deze postcode is al toegevoegd.', 'warning');
                                        return;
                                    } else if (postalCodeInput.trim() === '') {
                                        showSnackbarWithType('Voer een geldige postcode in.', 'warning');
                                        return;
                                    } else if (postalCodeInput.trim().length < 4 || postalCodeInput.trim().length > 6) {
                                        showSnackbarWithType('Postcode moet tussen de 4 en 6 karakters zijn.', 'warning');
                                        return;
                                    }

                                    if (postalCodeInput.trim() !== '') {
                                        this.setState({
                                            postalCodes: [...postalCodes, postalCodeInput.trim()],
                                            postalCodeInput: ''
                                        });
                                    }
                                }}>
                                    Voeg postcode toe
                                </button>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ postalCodes: this.state.lastSelectedMelding.postalCodes || [], initialPostalCodes: this.state.lastSelectedMelding.postalCodes || [] })}>
                                    Reset
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showPostalcodesModal: false, initialPostalCodes: [], postalCodes: [] })}>
                                    Sluiten
                                </button>
                                <button type="button" className="btn btn-primary" onClick={() => this.handleSavePostalcodes()}>
                                    Opslaan
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showAttachmentsModal}
                    onRequestClose={() => this.setState({ showAttachmentsModal: false, selectedAttachments: [] })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Bijlages</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showAttachmentsModal: false, selectedAttachments: [] })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Sluiten</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="attachments-list" style={{ marginTop: 10 }}>
                                {this.state.selectedAttachments && this.state.selectedAttachments.length > 0 ? (
                                    <LightGallery
                                        speed={500}
                                        plugins={[lgZoom, lgThumbnail]}
                                    >
                                        {this.state.selectedAttachments.map((attachment, index) => (
                                            isImage(attachment.type) && (
                                                <a key={index} href={attachment.url} target="_blank" rel="noopener noreferrer">
                                                    <img src={attachment.url} crossOrigin="anonymous" alt={attachment.name} style={{ padding: 6, maxWidth: 200, maxHeight: 200, borderRadius: 4, objectFit: 'cover' }} />
                                                </a>
                                            )
                                        ))}

                                    </LightGallery>
                                ) : (
                                    <p></p>
                                )}
                                {this.state.selectedAttachments && this.state.selectedAttachments.length > 0 ? (
                                    <LightGallery
                                        speed={500}
                                        plugins={[lgVideo]}
                                    >
                                        {this.state.selectedAttachments.map((attachment, index) => (
                                            attachment.type == 'wav' && (
                                                <video
                                                    controls
                                                    poster=".\assets\updatet_wewatch_transparent.png" preload="none"
                                                    style={{ maxWidth: 200, maxHeight: 200, borderRadius: 4, marginRight: 6, marginBottom: 6 }}>
                                                    <source src={attachment.url} type={'audio/ogg'} />
                                                </video>
                                            ) ||
                                            isVideo(attachment.type) && (
                                                <video
                                                    controls
                                                    poster=".\assets\updatet_wewatch_transparent.png" preload="none"
                                                    style={{ maxWidth: 200, maxHeight: 200, borderRadius: 4, marginRight: 6, marginBottom: 6 }}>
                                                    <source src={attachment.url} type={'video/' + attachment.type} />
                                                </video>
                                            )

                                        ))}

                                    </LightGallery>
                                ) : (
                                    <p></p>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this
                                .setState({ showAttachmentsModal: false, selectedAttachments: [] })}>Sluiten</button>
                        </div>
                    </div>

                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showClickedMediaDialog}
                    onRequestClose={() => this.setState({ showClickedMediaDialog: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={() => this.setState({ showClickedMediaDialog: false })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ textAlign: 'center' }}>
                            {(this.state.clickedMedia && isImage(this.state.clickedMedia.type)) && (
                                <LightGallery
                                    speed={500}
                                    plugins={[lgZoom, lgThumbnail]}
                                >
                                    {isImage(this.state.clickedMedia.type) && (
                                        <a href={this.state.clickedMedia.url} data-lg-size="1600-2400" data-src={this.state.clickedMedia.url} data-sub-html={this.state.clickedMedia.name}>
                                            <img src={this.state.clickedMedia.url} crossOrigin="anonymous" alt={this.state.clickedMedia.name} style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 4 }} />
                                        </a>
                                    )}

                                </LightGallery>
                            )}

                            {(this.state.clickedMedia && isVideo(this.state.clickedMedia.type)) && (
                                <LightGallery
                                    plugins={[lgVideo]}
                                >
                                    <video
                                        controls
                                        poster=".\assets\updatet_wewatch_transparent.png" preload="none"
                                        style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 4 }}>
                                        <source src={this.state.clickedMedia.url} type={'video/' + this.state.clickedMedia.type} />
                                    </video>
                                </LightGallery>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showClickedMediaDialog: false })}>Sluiten</button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showLastMessageAndCloseDialog}
                    onRequestClose={() => this.setState({ showLastMessageAndCloseDialog: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Melding afsluiten met bericht</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showLastMessageAndCloseDialog: false })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Dit bericht wordt toegevoegd aan de chat en de melding wordt gemarkeerd als gesloten.</p>
                            <textarea
                                className="form-control"
                                rows="6"
                                placeholder="Afsluitend bericht/dankwoord/vragen etc."
                                style={{ border: "1px solid gray", padding: 6 }}
                                value={this.state.lastMessageInput}
                                onChange={(e) => this.setState({ lastMessageInput: e.target.value })}
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showLastMessageAndCloseDialog: false })}>Sluiten</button>
                            <button type="button" className="btn btn-primary" onClick={() => {
                                const lastMessage = this.state.lastMessageInput.trim();
                                if (lastMessage) {
                                    realtimeDb.ref(`meldingen/${melding.id}`).child('status').set('gesloten');
                                    const msgRef = realtimeDb.ref(`chats/${melding.id}/messages`).push();
                                    const newMessage = {
                                        id: msgRef.key,
                                        text: lastMessage,
                                        files: [],
                                        ts: firebase.database.ServerValue.TIMESTAMP,
                                        uid: userData.uid,
                                    };
                                    realtimeDb.ref(`chats/${melding.id}/lastMessage`).set({
                                        id: msgRef.key,
                                        text: lastMessage,
                                        ts: firebase.database.ServerValue.TIMESTAMP,
                                        uid: userData.uid,
                                    });
                                    msgRef.set(newMessage).then(() => {
                                        realtimeDb.ref(`meldingen/${melding.id}`).update({
                                            lastMessage: newMessage,
                                            closingMessage: newMessage,
                                            status: 'gesloten',
                                        });
                                        this.setState({ showLastMessageAndCloseDialog: false, lastMessageInput: '' });

                                        showSnackbarWithType('Melding afgesloten met bericht', 'success');
                                    });
                                } else {
                                    showSnackbarWithType('Afsluitend bericht is verplicht', 'success');
                                }
                            }}>
                                Opslaan
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showUserProfileDialog}
                    onRequestClose={() => this.setState({ showUserProfileDialog: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Gebruikersprofiel</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showUserProfileDialog: false })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {fetchedUser && (
                                <div>
                                    <span style={{ marginBottom: 10 }}>Naam: {fetchedUser.displayName || 'Onbekend'}</span><br />
                                    <span style={{ marginBottom: 10 }}>Email: {fetchedUser.email || 'Onbekend'}</span><br />
                                    <span style={{ marginBottom: 10 }}>Mobiel: {fetchedUser.phoneNumber || 'Onbekend'}</span>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showUserProfileDialog: false })}>Sluiten</button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showAddUpdateModal}
                    onRequestClose={() => this.setState({ showAddUpdateModal: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{this.state.selectedUpdate ? "Update wijzigen" : "Update toevoegen"}</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showAddUpdateModal: false })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <div className="form-group">
                                <textarea className="form-control" id="updateText" rows="3" placeholder="Voer hier de update tekst in..."
                                    style={{ border: "1px solid gray", padding: 6 }}
                                    value={this.state.updateText}
                                    onChange={(e) => this.setState({ updateText: e.target.value })}
                                ></textarea>

                                <div className="form-group" style={{ marginTop: 10 }}>
                                    <label htmlFor="fileInput">Bijlagen toevoegen (optioneel):</label>
                                    <input type="file" className="form-control-file" id="fileInput" multiple accept="image/png, image/jpeg, image/webp, image/jpeg, audio/*,video/mp4, video/mp3, video/wav"
                                        onChange={(e) => {
                                            const newAttachments = Array.from(e.target.files);

                                            this.setState(prevState => ({
                                                newAttachments: [...prevState.newAttachments, ...newAttachments]
                                            }));
                                        }} />
                                </div>
                                <div className="form-group" style={{ marginTop: 10 }}>
                                    <label htmlFor="audioFileInputMsg">Geluid opnemen (optioneel):</label>
                                    <AudioRecorder />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showAddUpdateModal: false, selectedUpdate: null })}>Annuleren</button>
                                <button type="button" className="btn btn-primary btn-raised" onClick={() => this.addUpdateToMelding()}>Opslaan</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showAddChatMessageModal}
                    onRequestClose={() => this.setState({ showAddChatMessageModal: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Bericht toevoegen</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showAddChatMessageModal: false })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <div className="form-group">
                                <textarea className="form-control" id="updateText" rows="3" placeholder="Voer hier uw bericht in..."
                                    style={{ border: "1px solid gray", padding: 6 }}
                                    value={this.state.chatText}
                                    onChange={(e) => this.setState({ chatText: e.target.value })}
                                ></textarea>
                                <div className="form-group" style={{ marginTop: 10 }}>
                                    <label htmlFor="fileInputMsg">Bijlagen toevoegen (optioneel):</label>
                                    <input type="file" className="form-control-file" id="fileInputMsg" multiple accept="image/png, image/jpeg, image/webp, image/jpeg, audio/*,video/mp4, video/mp3, audio/wav, video/wav"
                                        onChange={(e) => {
                                            const newAttachments = Array.from(e.target.files);

                                            this.setState(prevState => ({
                                                newAttachments: [...prevState.newAttachments, ...newAttachments]
                                            }));
                                        }} />
                                </div>
                                <div className="form-group" style={{ marginTop: 10 }}>
                                    <label htmlFor="audioFileInputMsg">Geluid opnemen (optioneel):</label>
                                    <AudioRecorder />
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showAddChatMessageModal: false, lastSelectedChatMessage: null })}>Annuleren</button>
                            <button type="button" className="btn btn-primary btn-raised" onClick={() => this.addMessageToMelding()}>Opslaan</button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showMapModal}
                    onRequestClose={this.closeMapModal}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Melding locatie (ter hoogte van)</h4>
                            <button type="button" className="close" onClick={() => this.closeMapModal()}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Annuleren</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span><strong>{melding.address ? melding.address : ''}</strong></span>
                            {this.createMap(melding)}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.closeMapModal()}>Sluiten</button>
                        </div>
                    </div>
                </Modal>
            </div>);
    }

    createMap(melding) {
        let latPos = melding.nearbyLocation.lat;
        let longPos = melding.nearbyLocation.lng;

        if (latPos === undefined) {
            latPos = melding.nearbyLocation[0];
            longPos = melding.nearbyLocation[1];
        }

        return (<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['marker']}><Map style={{ height: '400px', width: '100%' }} mapId={"MeldingenDetailsMap"} defaultZoom={15} clickableIcons={false} defaultCenter={{ lat: latPos, lng: longPos }}>
            <Marker position={{ lat: latPos, lng: longPos }} />
        </Map></APIProvider>);
    }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(MeldingenDetailsScreen);